const GBMConfig = {
  name: 'Geometric Brownian Motion',
  description: 'Models asset prices with constant drift and volatility.',
  inputs: [
    {
      name: 'initialValue',
      label: 'Initial Portfolio Value',
      type: 'number',
      defaultValue: 100000,
    },
    {
      name: 'expectedReturn',
      label: 'Expected Annual Return (%)',
      type: 'number',
      defaultValue: 7,
      min: -50,
      max: 50,
      scaledBy: 100
    },
    {
      name: 'riskTolerance',
      label: 'Risk Tolerance',
      type: 'slider',
      defaultValue: 20,
      min: 1,
      max: 50,
      step: 1,
      scaledBy: 100
    },
  ],
  mapParams: {
    initialValue: 's0',
    expectedReturn: 'mu',
    riskTolerance: 'sigma'
  }
};

const OUConfig = {
  name: 'Ornstein-Uhlenbeck',
  description: 'Models mean-reverting processes like interest rates.',
  inputs: [
    {
      name: 'initialValue',
      label: 'Initial Value',
      type: 'number',
      defaultValue: 100000,
    },
    {
      name: 'longTermMean',
      label: 'Long-term Mean',
      type: 'number',
      defaultValue: 7,
      min: -20,
      max: 20,
      scaledBy: 100
    },
    {
      name: 'meanReversionSpeed',
      label: 'Mean Reversion Speed',
      type: 'slider',
      defaultValue: 0.1,
      min: 0.01,
      max: 1,
      step: 0.01,
    },
    {
      name: 'volatility',
      label: 'Volatility',
      type: 'number',
      defaultValue: 7,
      min: 1,
      max: 20,
      scaledBy: 100
    },
  ],
  mapParams: {
    initialValue: 'x0',
    longTermMean: 'mu',
    meanReversionSpeed: 'theta',
    volatility: 'sigma'

  }
};

const JDConfig = {
  name: 'Jump Diffusion',
  description: 'Models asset prices with occasional jumps.',
  inputs: [
    {
      name: 'initialValue',
      label: 'Initial Portfolio Value',
      type: 'number',
      defaultValue: 100000,
    },
    {
      name: 'expectedReturn',
      label: 'Expected Annual Return (%)',
      type: 'number',
      defaultValue: 7,
      min: -20,
      max: 20,
    },
    {
      name: 'riskTolerance',
      label: 'Risk Tolerance',
      type: 'slider',
      defaultValue: 5,
      min: 1,
      max: 10,
      step: 1,
    },
    {
      name: 'jumpIntensity',
      label: 'Jump Intensity',
      type: 'number',
      defaultValue: 0.1,
      min: 0,
      max: 10,
      step: 0.1,
    },
    {
      name: 'jumpSize',
      label: 'Average Jump Size (%)',
      type: 'number',
      defaultValue: -10,
      min: -50,
      max: 50,
    },
  ],
  mapParams: {
    initialValue: 's0',
    expectedReturn: 'mu',
    riskTolerance: 'sigma'
  }
};


export {
    GBMConfig,
    OUConfig,
    JDConfig,
}